/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AuditResponse,
  CommentAddAttachmentRequest,
  CommentMessageRequest,
  CommentRequestDataWithFiles,
  CommentResponse,
  GoogleDriveFilePointer,
  LocationFloorMapsRequest,
  LocationRequest,
  LocationRequestDataWithFiles,
  LocationResponse,
  LocationTargetResponse,
  LocationTargetUpdateRequest,
  PageResponseLocationResponse,
  PageResponseLocationWithSpacesResponse,
  PersonOfContactResponse,
  PostgresFilePointer,
  S3FilePointer,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Locations<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Retrieve location targets with optional filters by location IDs, names, or types
   *
   * @tags Location Targets
   * @name GetLocationTargets
   * @summary Get Location Revenue Targets
   * @request GET:/locations/targets
   * @secure
   * @response `200` `LocationTargetResponse` OK
   */
  getLocationTargets = (
    query?: {
      locationIds?: string[];
      locationNames?: string[];
      locationTypes?: (
        | "AIRPORT"
        | "BUSINESS_CENTER"
        | "CINEMA"
        | "FITNESS_CENTER"
        | "GAS_STATION"
        | "HYPERMARKET"
        | "HOTEL"
        | "MEDICAL_CENTER"
        | "RESIDENTIAL"
        | "SPORT"
        | "SHOPPING_GALLERY"
        | "SHOPPING_MALL"
        | "PUBLIC_TRANSPORT"
        | "SUPERMARKET"
      )[];
    },
    params: RequestParams = {},
  ) =>
    this.request<LocationTargetResponse, any>({
      path: `/locations/targets`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Update or create revenue targets for locations. Supports partial updates.
   *
   * @tags Location Targets
   * @name UpdateLocationTargets
   * @summary Update Location Revenue Targets
   * @request PUT:/locations/targets
   * @secure
   * @response `200` `LocationTargetResponse` OK
   */
  updateLocationTargets = (
    data: LocationTargetUpdateRequest,
    params: RequestParams = {},
  ) =>
    this.request<LocationTargetResponse, any>({
      path: `/locations/targets`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name AddLocation
   * @request POST:/locations
   * @secure
   * @response `200` `LocationResponse` OK
   */
  addLocation = (
    data: LocationRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<LocationResponse, any>({
      path: `/locations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetLocationGeometry
   * @summary Get Location Geometry
   * @request GET:/locations/{locationId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  getLocationGeometry = (locationId: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/locations/${locationId}/geometry`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name UpdateLocationGeometry
   * @summary Update Location Geometry
   * @request POST:/locations/{locationId}/geometry
   * @secure
   * @response `200` `string` OK
   */
  updateLocationGeometry = (
    locationId: string,
    data: string,
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/locations/${locationId}/geometry`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetLocationFloorMaps
   * @request GET:/locations/{locationId}/floorMaps
   * @secure
   * @response `200` `Record<string,((GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer))[]>` OK
   */
  getLocationFloorMaps = (locationId: string, params: RequestParams = {}) =>
    this.request<
      Record<
        string,
        (GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer)[]
      >,
      any
    >({
      path: `/locations/${locationId}/floorMaps`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name UpdateLocationFloorMaps
   * @request POST:/locations/{locationId}/floorMaps
   * @secure
   * @response `200` `Record<string,((GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer))[]>` OK
   */
  updateLocationFloorMaps = (
    locationId: string,
    data: LocationFloorMapsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      Record<
        string,
        (GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer)[]
      >,
      any
    >({
      path: `/locations/${locationId}/floorMaps`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name ListLocations
   * @request POST:/locations/getLocations
   * @secure
   * @response `200` `PageResponseLocationResponse` OK
   */
  listLocations = (data: LocationRequest, params: RequestParams = {}) =>
    this.request<PageResponseLocationResponse, any>({
      path: `/locations/getLocations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name ListLocationsWithSpaces
   * @request POST:/locations/getLocationsWithSpaces
   * @secure
   * @response `200` `PageResponseLocationWithSpacesResponse` OK
   */
  listLocationsWithSpaces = (
    data: LocationRequest,
    params: RequestParams = {},
  ) =>
    this.request<PageResponseLocationWithSpacesResponse, any>({
      path: `/locations/getLocationsWithSpaces`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetComments2
   * @request GET:/locations/comments/{resourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getComments2 = (resourceId: string, params: RequestParams = {}) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/locations/comments/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name AddComment2
   * @request POST:/locations/comments/{resourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addComment2 = (
    resourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/locations/comments/${resourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name AddCommentForChild2
   * @request POST:/locations/comments/{resourceId}/{subResourceId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addCommentForChild2 = (
    resourceId: string,
    subResourceId: string,
    data: CommentRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/locations/comments/${resourceId}/${subResourceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DeleteAttachments2
   * @request POST:/locations/comments/deleteAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  deleteAttachments2 = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/locations/comments/deleteAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name AddAttachments2
   * @request POST:/locations/comments/addAttachments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  addAttachments2 = (
    commentId: string,
    data: CommentAddAttachmentRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/locations/comments/addAttachments/${commentId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetLocationById
   * @summary Get Location by ID
   * @request GET:/locations/{locationId}
   * @secure
   * @response `200` `LocationResponse` OK
   */
  getLocationById = (locationId: string, params: RequestParams = {}) =>
    this.request<LocationResponse, any>({
      path: `/locations/${locationId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DeleteLocation
   * @request DELETE:/locations/{locationId}
   * @secure
   * @response `200` `LocationResponse` OK
   */
  deleteLocation = (locationId: string, params: RequestParams = {}) =>
    this.request<LocationResponse, any>({
      path: `/locations/${locationId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name UpdateLocation
   * @request PATCH:/locations/{locationId}
   * @secure
   * @response `200` `LocationResponse` OK
   */
  updateLocation = (
    locationId: string,
    data: LocationRequestDataWithFiles,
    params: RequestParams = {},
  ) =>
    this.request<LocationResponse, any>({
      path: `/locations/${locationId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DeleteComment2
   * @request DELETE:/locations/comments/{commentId}
   * @secure
   * @response `200` `void` OK
   */
  deleteComment2 = (commentId: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locations/comments/${commentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name UpdateCommentMessage2
   * @request PATCH:/locations/comments/{commentId}
   * @secure
   * @response `200` `CommentResponse` OK
   */
  updateCommentMessage2 = (
    commentId: string,
    data: CommentMessageRequest,
    params: RequestParams = {},
  ) =>
    this.request<CommentResponse, any>({
      path: `/locations/comments/${commentId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DownloadFloorMaps
   * @request GET:/locations/{locationId}/floorMaps/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadFloorMaps = (
    locationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/locations/${locationId}/floorMaps/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DeleteLocationFloorMaps
   * @request DELETE:/locations/{locationId}/floorMaps/{documentId}
   * @secure
   * @response `200` `Record<string,((GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer))[]>` OK
   */
  deleteLocationFloorMaps = (
    locationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      Record<
        string,
        (GoogleDriveFilePointer | PostgresFilePointer | S3FilePointer)[]
      >,
      any
    >({
      path: `/locations/${locationId}/floorMaps/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DownloadLocationDocuments
   * @summary Download Location Documents
   * @request GET:/locations/{locationId}/documents
   * @secure
   * @response `200` `StreamingResponseBody` OK
   */
  downloadLocationDocuments = (
    locationId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/locations/${locationId}/documents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DownloadLocationDocument
   * @summary Download Location Document
   * @request GET:/locations/{locationId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadLocationDocument = (
    locationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<Blob, any>({
      path: `/locations/${locationId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DeleteLocationDocument
   * @summary Delete Location Document
   * @request DELETE:/locations/{locationId}/documents/{documentId}
   * @secure
   * @response `200` `LocationResponse` OK
   */
  deleteLocationDocument = (
    locationId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<LocationResponse, any>({
      path: `/locations/${locationId}/documents/${documentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetHistory2
   * @request GET:/locations/history/{resourceId}
   * @secure
   * @response `200` `(AuditResponse)[]` OK
   */
  getHistory2 = (resourceId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], any>({
      path: `/locations/history/${resourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetContactCandidates
   * @request GET:/locations/contact-candidates
   * @secure
   * @response `200` `(PersonOfContactResponse)[]` OK
   */
  getContactCandidates = (
    query: {
      companyId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<PersonOfContactResponse[], any>({
      path: `/locations/contact-candidates`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name GetCommentsForChild2
   * @request GET:/locations/comments/{resourceId}/{subresourceId}
   * @secure
   * @response `200` `Record<string,(CommentResponse)[]>` OK
   */
  getCommentsForChild2 = (
    resourceId: string,
    subresourceId: string,
    params: RequestParams = {},
  ) =>
    this.request<Record<string, CommentResponse[]>, any>({
      path: `/locations/comments/${resourceId}/${subresourceId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name DownloadCommentInlineDocument2
   * @request GET:/locations/comments/{resourceId}/documents/{documentId}
   * @secure
   * @response `200` `File` OK
   */
  downloadCommentInlineDocument2 = (
    resourceId: string,
    documentId: string,
    params: RequestParams = {},
  ) =>
    this.request<File, any>({
      path: `/locations/comments/${resourceId}/documents/${documentId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags location-controller
   * @name ListCities
   * @request GET:/locations/cities
   * @secure
   * @response `200` `Record<string,(string)[]>` OK
   */
  listCities = (params: RequestParams = {}) =>
    this.request<Record<string, string[]>, any>({
      path: `/locations/cities`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Delete all or specific year targets for a location
   *
   * @tags Location Targets
   * @name DeleteLocationTargets
   * @summary Delete Location Revenue Targets
   * @request DELETE:/locations/targets/{locationId}
   * @secure
   * @response `200` `LocationTargetResponse` OK
   */
  deleteLocationTargets = (
    locationId: string,
    query?: {
      years?: number[];
    },
    params: RequestParams = {},
  ) =>
    this.request<LocationTargetResponse, any>({
      path: `/locations/targets/${locationId}`,
      method: "DELETE",
      query: query,
      secure: true,
      ...params,
    });
}
